module.exports = __webpack_public_path__ + "img/CM-MC-25-Buick-Established.ae2aecba.jpg";